import { render, staticRenderFns } from "./Dependentes.vue?vue&type=template&id=bc7cfc92&scoped=true"
import script from "./Dependentes.vue?vue&type=script&lang=js"
export * from "./Dependentes.vue?vue&type=script&lang=js"
import style0 from "./Dependentes.vue?vue&type=style&index=0&id=bc7cfc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7cfc92",
  null
  
)

export default component.exports